import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_MISSING_DOCS_APPLICATION_QUERY = gql`
  query ApplicationMissingDocs($input: ApplicationInput!) {
    application(input: $input) {
      documents {
        id
        status
        documentType
        name
      }
    }
  }
`;
